// extracted by mini-css-extract-plugin
export var copyableField = "_s2-4";
export var customerBadge = "_s2-0";
export var customerInfoTitle = "_s2-2";
export var details = "_s2-1";
export var dropdownContainer = "_s2-5";
export var dropdownImage = "_s2-6";
export var editAssigneeForm = "_s2-a";
export var editButton = "_s2-3";
export var email = "_s2-7";
export var hidden = "_s2-d";
export var input = "_s2-8";
export var saveButton = "_s2-b";
export var shopifyIcon = "_s2-c";
export var suggestionBadge = "_s2-e";
export var suggestionText = "_s2-f";
export var username = "_s2-9";